import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getStats } from '../api';

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState({ total_users: 0, total_resources: 0, total_logins: 0 });

  useEffect(() => {
    getStats().then((res) => setStats(res.data)).catch(() => {});
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div style={styles.container}>
      {/* Navbar */}
      <nav style={styles.nav}>
        <div style={styles.navBrand}>
          <span style={styles.navTitle}>Boothby Therapy Services</span>
          <span style={styles.navSubtitle}>Admin Panel</span>
        </div>
        <div style={styles.navRight}>
          <button onClick={() => navigate('/admin/users')} style={styles.navBtn}>👥 Users</button>
          <button onClick={() => navigate('/admin/resources')} style={styles.navBtn}>📚 Resources</button>
          <button onClick={() => navigate('/admin/profile')} style={styles.navBtn}>⚙️ Settings</button>
          <button onClick={handleLogout} style={styles.navBtnOutline}>Sign Out</button>
        </div>
      </nav>

      <div style={styles.content}>
        <div style={styles.welcome}>
          <h1 style={styles.welcomeTitle}>Admin Dashboard</h1>
          <p style={styles.welcomeSubtitle}>Welcome back, {user?.first_name}!</p>
        </div>

        {/* Stats */}
        <div style={styles.statsGrid}>
          <div style={styles.statCard}>
            <div style={styles.statIcon}>👥</div>
            <div style={styles.statNumber}>{stats.total_users}</div>
            <div style={styles.statLabel}>Active Employees</div>
          </div>
          <div style={styles.statCard}>
            <div style={styles.statIcon}>📄</div>
            <div style={styles.statNumber}>{stats.total_resources}</div>
            <div style={styles.statLabel}>Training Resources</div>
          </div>
          <div style={styles.statCard}>
            <div style={styles.statIcon}>🔐</div>
            <div style={styles.statNumber}>{stats.total_logins}</div>
            <div style={styles.statLabel}>Total Logins</div>
          </div>
        </div>

        {/* Quick Actions */}
        <div style={styles.actionsGrid}>
          <div style={styles.actionCard} onClick={() => navigate('/admin/users')}>
            <div style={styles.actionIcon}>👥</div>
            <h3 style={styles.actionTitle}>Manage Employees</h3>
            <p style={styles.actionDesc}>Add, edit, or remove employee accounts and reset passwords.</p>
            <button style={styles.actionBtn}>Go to Users →</button>
          </div>
          <div style={styles.actionCard} onClick={() => navigate('/admin/resources')}>
            <div style={styles.actionIcon}>📚</div>
            <h3 style={styles.actionTitle}>Manage Resources</h3>
            <p style={styles.actionDesc}>Upload training materials and manage access by employee role.</p>
            <button style={styles.actionBtn}>Go to Resources →</button>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', background: '#f8fafc', overflowX: 'hidden' },
  nav: {
    background: '#243C94',
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '8px',
  },
  navBrand: { display: 'flex', flexDirection: 'column' },
  navTitle: { color: '#ffffff', fontSize: '16px', fontWeight: '700' },
  navSubtitle: { color: '#FFA204', fontSize: '11px', fontWeight: '600', letterSpacing: '1px' },
  navRight: { display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' },
  navBtn: {
    background: 'rgba(255,255,255,0.15)',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    padding: '6px 10px',
    cursor: 'pointer',
    fontSize: '12px',
  },
  navBtnOutline: {
    background: 'transparent',
    color: '#ffffff',
    border: '2px solid rgba(255,255,255,0.5)',
    borderRadius: '8px',
    padding: '6px 10px',
    cursor: 'pointer',
    fontSize: '12px',
  },
  content: { maxWidth: '1200px', margin: '0 auto', padding: '24px 16px' },
  welcome: {
    background: '#ffffff',
    borderRadius: '12px',
    padding: '24px',
    marginBottom: '24px',
    borderLeft: '5px solid #FFA204',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  },
  welcomeTitle: { color: '#243C94', fontSize: '24px', fontWeight: '700', margin: '0 0 8px 0' },
  welcomeSubtitle: { color: '#6b7280', fontSize: '16px', margin: 0 },
statsGrid: {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
  gap: '16px',
  marginBottom: '24px',
},
  statCard: {
    background: '#ffffff',
    borderRadius: '12px',
    padding: '20px',
    textAlign: 'center',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    border: '1px solid #f0f0f0',
  },
  statIcon: { fontSize: '28px', marginBottom: '8px' },
  statNumber: { color: '#243C94', fontSize: '28px', fontWeight: '700', marginBottom: '4px' },
  statLabel: { color: '#6b7280', fontSize: '13px' },
  actionsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: '16px',
  },
actionsGrid: {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
  gap: '16px',
},
  actionIcon: { fontSize: '36px', marginBottom: '12px' },
  actionTitle: { color: '#1f2937', fontSize: '18px', fontWeight: '700', marginBottom: '8px' },
  actionDesc: { color: '#6b7280', fontSize: '14px', marginBottom: '16px' },
  actionBtn: {
    background: '#243C94',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 20px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
  },
};